import { NumericInput } from '../common/NumericInput';
import { cn } from '../../utils/cn';

/** `.pen` `ds/input/currency--hero`. */
export function QuickCreateHeroAmount({ label, value, onChange, className, autoFocus, inputLabel }) {
  return (
    <div className={cn('flex w-full flex-col gap-space-2', className)}>
      <div className="flex w-full flex-col items-center gap-space-2 rounded-ds-xl border border-sage-border bg-sage-tint px-space-4 py-space-5">
        <p className="type-label text-sage-on-tint">{label}</p>
        <div className="flex items-center gap-space-2">
          <NumericInput
            value={value}
            onChange={onChange}
            autoFocus={autoFocus}
            aria-label={inputLabel || label}
            style={{ width: `${Math.max(String(value || '0').length, 1)}ch` }}
            className="type-display-hero h-auto border-0 bg-transparent p-0 text-center leading-none tracking-tight text-card-foreground shadow-none focus-visible:ring-0"
          />
          <span className="type-display-metric leading-tight text-muted-foreground">€</span>
        </div>
      </div>
    </div>
  );
}
